module.exports = __webpack_public_path__ + "img/r3th-priv.36d15eb2.png";